import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "label-icon",
  "use": "label-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"label-icon\"><path d=\"M9.39 0v1.23H1.31c-.05 0-.09.03-.1.07l-.01.04v13.32c0 .05.03.09.07.1l.03.01h13.38c.05 0 .09-.03.1-.07l.01-.03v-7.9h1.23v7.89c0 .7-.54 1.28-1.23 1.33H1.31c-.7 0-1.28-.54-1.33-1.23V1.34C-.02.64.52.06 1.21.01h8.18zm2.67.97a1.22 1.22 0 0 1 1.73 0l1.34 1.34c.48.48.47 1.25 0 1.73L8.4 10.77c-.05.05-.11.09-.17.12l-3.99 1.69a.55.55 0 1 1-.72-.71l1.69-3.99c.03-.07.07-.13.12-.18L12.06.97zm-1.05 2.78L6.29 8.47 5.3 10.8l2.33-.99 4.72-4.72-1.34-1.34zm1.92-1.92l-1.05 1.05 1.34 1.34 1.05-1.05-1.34-1.34z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/label-icon.svg
// module id = hMGy
// module chunks = 6